import React, { useEffect, useState } from "react";
import { FaFacebookF, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { FaEarthAmericas } from "react-icons/fa6";
import { LuArrowUpRight } from "react-icons/lu";
import { IoSearchOutline, IoWarning } from "react-icons/io5";
import "../../css/items.scss";
import { serverInstance } from "../../service/axios";
import Dimmer from "../shared/Dimmer";
import "./clinics.scss";

const Clinics = ({ data, language }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allItems, setAllItems] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const isMongolian = language === "mn";
  const resultLabel = isMongolian ? "Хайлтын үр дүн" : "Search results";
  const mapLabel = isMongolian ? "Google газрын зураг" : "Google map";
  const websiteLabel = isMongolian ? "Вэбсайт" : "Website";
  const facebookLabel = "Facebook";

  useEffect(() => {
    window.scrollTo(0, 0);

    serverInstance.get("/app/clinics")
      .then(res => {
        const items = res.data.items.filter(item => !item.test)
        setAllItems(items)
        setFilteredData(items)
        setErrorMsg("");
        setLoading(false);
      })
      .catch((err) => {
        setErrorMsg(err);
        setLoading(false);
      })
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    const filtered = allItems.filter((item) => {
      return (
        (item.name && item.name.toLowerCase().includes(term)) ||
        (item.name_en && item.name_en.toLowerCase().includes(term)) ||
        (item.address && item.address.toLowerCase().includes(term)) ||
        (item.address_en && item.address_en.toLowerCase().includes(term)) ||
        (item.phone && item.phone.toLowerCase().includes(term))
      );
    });
    
    setFilteredData(filtered);
  };

  return (
    <div className='items-container' id='clinics'>
      {loading ? <Dimmer /> : null}

      <section className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>

          <div className="input-container">
            <input
              type='text'
              placeholder={data.placeholder}
              value={searchTerm}
              onChange={handleSearch}
              className=''
            />
            <button className="search-btn" type="button" aria-label={data.title}>
              <IoSearchOutline size={18} />
            </button>
          </div>
        </div>
      </section>

      <div className='main-container'>
        {errorMsg ? <div className="error-msg">
          <IoWarning/>
          &nbsp;
          {errorMsg}
        </div> : null}

        {!loading && filteredData.length === 0 ?
        <div className="archive-empty-state">{data.noData}</div>
        :
        <div className="search-result">
          <div className="count">{resultLabel}: {filteredData.length}</div>

          <div className="items">
            {filteredData.map((item) => {
              const clinicName = isMongolian ? item.name : item.name_en || item.name;
              const clinicAddress = isMongolian ? item.address : item.address_en || item.address;
              const imageUrl = item.fileUrl
                ? `https://msid-asset.s3.ap-northeast-2.amazonaws.com/${item.fileUrl}`
                : "/images/background.png";

              return (
                <article key={"clinic-" + item.id} className='clinic-item'>
                  <div className="clinic-img">
                    <img src={imageUrl} alt={clinicName || ""} />
                  </div>
                  <div className='clinic-info'>
                    <h3 className="clinic-name">{clinicName}</h3>
                    {clinicAddress ? (
                      <p className='clinic-address'>{clinicAddress}</p>
                    ) : null}
                    <div className="links">
                      {item.phone ?
                      <div className="contact">
                        <FaPhoneAlt aria-hidden="true" />
                        <span>{item.phone}</span>
                      </div> : null}
                      { item.webLink ?
                      <a className="contact" href={item.webLink} target="_blank" rel="noopener noreferrer">
                        <FaEarthAmericas aria-hidden="true" />
                        <span>{websiteLabel}</span>
                        <LuArrowUpRight className="external-icon" aria-hidden="true" />
                      </a> : null}
                      { item.mapLink ?
                      <a className="contact" href={item.mapLink} target="_blank" rel="noopener noreferrer">
                        <FaMapMarkerAlt aria-hidden="true" />
                        <span>{mapLabel}</span>
                        <LuArrowUpRight className="external-icon" aria-hidden="true" />
                      </a> : null}
                      { item.socialLink ?
                      <a className="contact" href={item.socialLink} target="_blank" rel="noopener noreferrer">
                        <FaFacebookF aria-hidden="true" />
                        <span>{facebookLabel}</span>
                        <LuArrowUpRight className="external-icon" aria-hidden="true" />
                      </a> : null}
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
        }
      </div>
    </div>
  );
};

export default Clinics;
